import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthInterceptors } from "@/lib/auth";

// Attach the bearer token to every axios call and handle 401s globally.
// Must run before any component mounts and fires a request.
installAuthInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
